import React, { useState, useEffect } from "react";
import { DropdownIcon } from "../../../assets/icons/index.jsx";
import CategoriesHeader from "./CategoriesHeader.jsx";
import { navItems, categoryItems } from "../../../data/categories";

export default function MobileMenu({ isOpen, onClose }) {
  const [catOpen, setCatOpen]         = useState(false);
  const [activeGroup, setActiveGroup] = useState(null); 
  
  useEffect(() => {
    if (!isOpen) {
      setCatOpen(false);
    }
  }, [isOpen]);

  
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  
  const MainPanel = (
    <div
      className={`absolute inset-0 flex flex-col transition-transform duration-300 ease-in-out
        ${catOpen ? "-translate-x-full" : "translate-x-0"}`}
    >
      

      {/* Nav list */}
      <nav className="flex-1 overflow-y-auto py-16">

        {/* Categories — opens sub-panel */}
        <button
          onClick={() => setCatOpen(true)}
          className="w-full flex items-center justify-between px-6 py-4
            text-[var(--text-light)] border-b border-white/10
            hover:bg-white/5 active:bg-white/10 transition-colors"
        >
          <span className="flex items-center gap-3">
            <span className="text-[15px] font-semibold"
                  style={{ fontFamily: "Poppins, sans-serif" }}>Categories</span>
          </span>
          <DropdownIcon size={14} className="-rotate-90" />
        </button>

        {/* Regular links */}
        {navItems.map(item => (
          <a
            onClick={onClose}
            className="flex items-center gap-3 px-6 py-4 text-[var(--text-light)]
              border-b border-white/10 hover:bg-white/5 active:bg-white/10
              transition-colors text-[15px] font-medium"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            {item}
          </a>
        ))}
      </nav>

    </div>
  );

  // ── panel: categories ──────────────────────────────────────────────────────
const CategoriesPanel = (
  <div
    className={`absolute inset-0 flex flex-col transition-transform duration-300 ease-in-out
      ${catOpen ? "translate-x-0" : "translate-x-full"}`}
  >
    {/* Header */}
    <div className="flex items-center gap-3 px-4 py-4 border-b border-white/10">
      <button
        onClick={() => setCatOpen(false)}
        className="text-[var(--text-light)] p-1 hover:opacity-70"
        aria-label="Back"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <span className="text-[var(--text-light)] font-bold text-[16px]"
            style={{ fontFamily: "Poppins, sans-serif" }}>Categories</span>
    </div>

    {/* Same list, mobile-friendly styles */}
    <ul className="overflow-y-auto py-2">
      {categoryItems.map((item) => (
        <li key={item}>
          
           <a href="#"
            onClick={onClose}
            className="flex items-center gap-3 px-6 py-4
              text-[var(--text-light)] border-b border-white/10
              hover:bg-white/5 active:bg-white/10 transition-colors
              text-[15px] font-medium"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            {item}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

  // drawer shell
  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        className={`fixed inset-0 z-40 bg-black/50 backdrop-blur-sm
          transition-opacity duration-300
          ${isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
      />

      {/* Drawer */}
      <div
        className={`fixed top-0 left-0 h-full w-[85%] max-w-[360px] z-50
          bg-[var(--primary-dark)] shadow-2xl
          transition-transform duration-300 ease-in-out overflow-hidden
          ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-white/60 hover:text-white
            w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10"
          aria-label="Close menu"
        >
          ✕
        </button>

        {/* Panels container — slides between main and categories */}
        <div className="relative w-full h-full">
          {MainPanel}
          {CategoriesPanel}
        </div>
      </div>
    </>
  );
}